import { IntlShape } from './useIntl';

export const constructFormattedNumberResponse = (
  intl: IntlShape,
  value: number,
  maximumFractionDigits: number = 2,
  forceDigits?: boolean
) => {
  const roundedValue = maximumFractionDigits ? value : Math.ceil(value);

  return intl.formatNumber(roundedValue, {
    minimumFractionDigits: forceDigits ? maximumFractionDigits : 0,
    maximumFractionDigits,
  });
};

export const getFormattedNumber = (
  intl: IntlShape,
  value: number,
  maximumFractionDigits: number = 2,
  forceDigits?: boolean
) => {
  return constructFormattedNumberResponse(
    intl,
    value,
    maximumFractionDigits,
    forceDigits
  );
};
